import type * as Types from 'app/types/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type CampaignVariantTargetsQueryVariables = Types.Exact<{
  campaignType?: Types.InputMaybe<Array<Types.CampaignType>>;
  status?: Types.InputMaybe<Array<Types.CampaignStatus>>;
  templateType?: Types.InputMaybe<Types.VariantTemplateType>;
}>;

export type CampaignVariantTargetsQueryResponse = {
  campaignVariantTargets: Array<
    Pick<
      Types.CampaignVariantTarget,
      'campaignID' | 'campaignName' | 'campaignType' | 'targetPageIDs' | 'campaignStatus'
    > & {
      campaignGroup?: Types.Maybe<Pick<Types.CampaignVariantTargetGroup, 'id' | 'title'>>;
      variants: Array<
        Pick<
          Types.VariantTarget,
          'baseID' | 'isOrigin' | 'templateSuffix' | 'redirectURL' | 'id'
        > & { variantType?: Types.Maybe<Pick<Types.VariantTargetType, 'id' | 'kind'>> }
      >;
    }
  >;
};

export const CampaignVariantTargetsDocument = `
    query CampaignVariantTargets($campaignType: [CampaignType!], $status: [CampaignStatus!], $templateType: VariantTemplateType) {
  campaignVariantTargets(
    campaignType: $campaignType
    status: $status
    templateType: $templateType
  ) {
    campaignID
    campaignName
    campaignType
    campaignGroup {
      id
      title
    }
    targetPageIDs
    campaignStatus
    variants {
      baseID
      isOrigin
      templateSuffix
      redirectURL
      id
      variantType {
        id
        kind
      }
    }
  }
}
    `;

export const useCampaignVariantTargetsQuery = <
  TData = CampaignVariantTargetsQueryResponse,
  TError = unknown,
>(
  variables?: CampaignVariantTargetsQueryVariables,
  options?: UseQueryOptions<CampaignVariantTargetsQueryResponse, TError, TData>,
) => {
  return useQuery<CampaignVariantTargetsQueryResponse, TError, TData>(
    variables === undefined ? ['CampaignVariantTargets'] : ['CampaignVariantTargets', variables],
    appFetcher<CampaignVariantTargetsQueryResponse, CampaignVariantTargetsQueryVariables>(
      CampaignVariantTargetsDocument,
      variables,
    ),
    options,
  );
};

useCampaignVariantTargetsQuery.getKey = (variables?: CampaignVariantTargetsQueryVariables) =>
  variables === undefined ? ['CampaignVariantTargets'] : ['CampaignVariantTargets', variables];
